import React, { useEffect, useState } from 'react';
import { Box, Flex, Text, Image, Spinner } from '@chakra-ui/react';
import PowerBy from './powerby';

const Step3 = ({ setStep }) => {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => {
      setStep(4);
      setLoading(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, [setStep]);
  return (
    <Box w={{ base: '100%', md: '840px' }} m="40px auto 0" p={{ base: '10px', md: '190px 220px' }} minH="85vh">
      <Flex justifyContent="center" textAlign="center" mb="30px">
        <Text fontSize="14px" color="#000">
          <b>Minting in process..</b> This can take a <br /> few minutes
        </Text>
      </Flex>
      <Flex justifyContent="center" mb="40px">
        <Spinner thickness="4px" speed="0.65s" size="xl" />
      </Flex>
      {/* <PowerBy /> */}
    </Box>
  );
};

export default Step3;
